



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { Base } from '@/components/common/base';
import { storeService } from '@/shared';
import { InvoiceConfig } from '@/models/admin/store';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
})
export default class InvoiceConfigSavePage extends Base {
  public stores: any[];
  public configModel: InvoiceConfig = {
    id: '',
    key: '',
    value: [],
  };

  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public storeId: number = 0;
  public disableSubmitButton: boolean = false;
  public tagValue: any = [];

  public created(): void {
    this.setFields();
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.$router.push({
        name: 'admin.invoiceConfig',
        params: { storeId: this.storeId.toString() },
      });
    }
    if (methodName === 'submit') {
      if (!this.form.$valid || this.disableSubmitButton) {
        this.showAlert(false, 'Form is Invalid!');
        this.resetMethodName(methodName);
        return;
      }
      this.submitInvoice();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$parent.$t('shifts.btnBack'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('shifts.btnBack'),
      click: 'backToList',
      icon: 'fas fa-arrow-left',
    });
    this.$emit('updateToolBar', buttons);
  }
  public async mounted(): Promise<void> {
    this.storeId = Number(this.$route.params.storeId);
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (this.$route.params.id) {
      this.getInvoice(this.$route.params.id);
    }
  }
  public async submitInvoice(): Promise<void> {
    try {
      this.disableSubmitButton = true;
      this.$emit('update:progress', this.disableSubmitButton);
      if (this.$route.params.id) {
        await storeService.updateInvoiceConfig(this.storeId, this.configModel);
        this.showAlert(true, 'Config Updated Successfully');
        this.$router.push({
          name: 'admin.invoiceConfig',
          params: { storeId: this.storeId.toString() },
        });
      } else {
        await storeService.saveInvoiceConfig(this.storeId, this.configModel);
        this.showAlert(true, 'Config added Successfully');
        this.$router.push({
          name: 'admin.invoiceConfig',
          params: { storeId: this.storeId.toString() },
        });
      }
    } finally {
      this.disableSubmitButton = false;
      this.$emit('update:progress', this.disableSubmitButton);
    }
  }
  public async getInvoice(id: string): Promise<void> {
    try {
      this.formlyShowSkeleton(this.formFields);
      const invoiceConfig = await storeService.getInvoiceById(id, this.storeId);
      this.configModel = invoiceConfig;
    } finally {
      this.formlyHideSkeleton(this.formFields);
    }
  }

  public removeInvoiceTags(value) {
    const index = this.configModel.value.indexOf(value);
    if (index > -1) {
      this.configModel.value.splice(index, 1);
    }
  }

  public setFields(): void {
    this.formFields = [
      {
        key: 'key',
        required: true,
        type: 'v-alynk-text-field',
        templateOptions: {
          disabled: false,
          required: true,
          validations: 'required',
          label: 'Name',
          loading: false,
        },
      },
      {
        key: 'value',
        type: 'v-alynk-textchip',
        required: false,
        templateOptions: {
          label: 'Configuration Value',
          multiple: true,
          validations: 'required',
          required: false,
          items: this.tagValue,
          disabled: false,
          events: {
            onChange: (items, value) => {
              //  this.addInvoiceTags(value);
            },
            onRemove: (item, value) => {
              this.removeInvoiceTags(value);
            },
          },
          loading: false,
        },
      },
    ];
  }
}
